import { gql } from '@apollo/client'

export const TRACK_JOB_QUERY = gql`
  query TrackJob($trackingID: String!) {
    trackJob(trackingID: $trackingID) {
      status
    }
  }
`
